import React, { useEffect, useRef } from 'react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  role: string;
  image: string;
}

function TestimonialCard({ quote, author, role, image }: TestimonialCardProps) {
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      {
        threshold: 0.5, // Changed from 0.1 to 0.5 to trigger when element is halfway visible
        rootMargin: '0px' // Ensures the calculation is relative to the viewport
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <div ref={cardRef} className="p-6 sm:p-8 border border-white/10 rounded-lg feature-card">
      <p className="text-lg sm:text-xl text-white/80 mb-4 sm:mb-6">"{quote}"</p>
      <div className="flex items-center">
        <img src={image} alt={author} className="w-12 h-12 sm:w-16 sm:h-16 rounded-full mr-4" />
        <div>
          <p className="text-base sm:text-lg font-semibold text-white">{author}</p>
          <p className="text-sm sm:text-base text-white/60">{role}</p>
        </div>
      </div>
    </div>
  );
}

export default TestimonialCard;